import { useContext } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import colorContext from '../../../../Context/colorContext';

export function useRatingStyles() {
    const { colors } = useContext(colorContext);
    const useStyles = makeStyles((theme: Theme) => ({
        main: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBottom: '64px',
            borderBottom: `1px solid ${colors.dividerColor}`,
        },
        boxRating: {
            maxWidth: 1040,
            width: '100%',
            padding: '56px 0px 48px 0px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
        },
        titleRating: {
            fontFamily: 'Open Sans',
            fontSize: theme.typography.pxToRem(24),
            fontWeight: 700,
            color: colors.textBlackGray,
            marginBottom: 24,
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(18),
                padding: '0px 16px',
            },
        },
        buttonRating: {
            border: `1px solid ${colors.accentColor}`,
            borderRadius: 4,
            padding: '4px 24px',
            margin: '10px 10px 40px 10px',
            color: colors.accentColor,
        },
        boxButtonsRating: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
        },
        buttonClose: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(0.5),
            color: colors.textAccentColor,
        },
        header: {
            background: colors.accentColorBackground,
        },
        textHeader: {
            display: 'flex',
            alignItems: 'center',
            textTransform: 'uppercase',
            width: '90%',
            color: colors.textAccentColor,
        },
        numberEvaluations: {
            color: colors.textBody,
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 400,
            lineHeight: '21px',
            marginTop: 16,
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(13),
            },
        },
        ratingRoot: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
        },
        iconStar: {
            color: colors.accentColor,
            width: 40,
            height: 40,
        },
        iconEmpty: {
            color: 'rgba(136, 136, 136, 0.2)',
        },
        content: {
            padding: 32,
        },
        button: {
            color: colors.accentColor,
            '&:last-child': {
                backgroundColor: colors.accentColor,
                color: colors.colorBackground,
            },
        },
        buttonIcons: {
            width: 70,
            height: 70,
        },
        iconOk: {
            fontSize: 60,
            '&:hover': {
                color: colors.accentColor,
            },
        },
        iconOkSelected: {
            fontSize: 60,
            color: colors.accentColor,
        },
        iconNotOk: {
            fontSize: 60,
            '&:hover': {
                color: '#FF0000',
            },
        },
        iconNotOkSelected: {
            fontSize: 60,
            color: '#FF0000',
        },
        simplifyButton: {
            borderRadius: '5rem',
            borderWidth: '2px',
            padding: '0.5rem 3rem',
            fontSize: '1.2rem',
            '&:hover': {
                borderWidth: '2px',
            },
        }
    }));
    const classes = useStyles();

    return {
        classes,
        colors,
    }
}